import { FunctionComponent, useCallback, useState } from "react";
import { useAppDispatch, useAppSelector } from "@store/store";
import { useTranslation } from "react-i18next";
import { FormStatus } from "../../../../components/formFields/FormStatus";
import { AuthSubmitButton } from "../../components/AuthSubmitButton/AuthSubmitButton";
import { AuthInstructions } from "../../components/AuthInstructions/AuthInstructions";
import { AuthError } from "../../components/AuthError/AuthError";
import { selectEmail } from "@store/sessionReducer";
import { EmailField } from "../../../../components/formFields/EmailField/EmailField";
import { sendMagicLinkAction } from "@store/auth/actions/sendMagicLinkAction";
import { Form } from "antd";
interface MagicLinkExpiredProps {}

const MagicLinkExpired: FunctionComponent<MagicLinkExpiredProps> = () => {
  const [state, setState] = useState<{ status: FormStatus }>({
    status: "idle",
  });
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const email = useAppSelector(selectEmail);
  const hasStoredEmail = !!email;
  const instructionValues = {
    additionalDescription: hasStoredEmail
      ? t("screens.auth.magicLinkExpired.withStoredEmail")
      : t("screens.auth.magicLinkExpired.withoutStoredEmail"),
  };

  const handleResendLink = useCallback(
    async (values: { email: string }) => {
      setState({ status: "fetching" });
      try {
        await dispatch(
          sendMagicLinkAction({
            email: values.email,
          }),
        );
        setState({ status: "success" });
      } catch (_error) {
        setState({ status: "error" });
      }
    },
    [dispatch],
  );

  const disabled = state.status === "fetching" || state.status === "success";

  return (
    <>
      <AuthInstructions values={instructionValues} />
      <div className="form-container">
        <Form
          form={form}
          name="signInEmail"
          layout="vertical"
          onFinish={handleResendLink}
          disabled={disabled}
          initialValues={{ email: email ?? "" }}>
          <EmailField
            autoComplete="username"
            disabled={hasStoredEmail}
            hidden={hasStoredEmail}
          />
          <div className="form-button-container">
            <AuthSubmitButton
              label={t("screens.auth.magicLinkExpired.newLink")}
              disabled={disabled}
            />
          </div>
        </Form>
      </div>

      {state.status === "error" && <AuthError />}
    </>
  );
};

export { MagicLinkExpired };
